// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + chunkId + "." + {25: "00d0189e4884e2998a64",504: "84f8c9a938d44abdc656",}[chunkId] + ".js"
}